export const TRADE_LINK_REG_EXP = /^(http|https):\/\/steamcommunity.com\/tradeoffer\/new\/\?partner=([0-9]+)&token=([-a-zA-Z0-9_]+)/;

export const STEAM_API_KEY_REG_EXP = /^[A-Z0-9]{32}$/;

export const EMAIL_REG_EX = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
